import styled from "styled-components";
import { motion } from "framer-motion";

export const ContainerPuntoControl = styled(motion.div)`
  width: 100vw;
  /* height: 80vh; */
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 40px;

  h1 {
    font-size: ${({ $isTerminal }) => ($isTerminal ? "32px" : "24px")};
  }
  span {
    text-align: center;
    font-size: ${({ $isTerminal }) => ($isTerminal ? "24px" : "20px")};
    font-weight: 400;
  }
  img {
    width: 200px;
    height: 200px;
    object-fit: contain;
  }
  .danger {
    width: 211px;
    height: 49px;
    background: var(--color-danger);
    border-radius: 8px;
    font-size: 18px;
    color: var(--color-white);
    /* margin-top: 30px; */
  }
`;
